module.exports = __webpack_public_path__ + "static/img/nawiPoczatek-OFF.d96ea8c1.png";